import { ValidationObserver } from 'vee-validate';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UploadItem } from '@/store/models/uploadPopup';
import MDTextFieldWithValidation from '../Validation/MDTextFieldWithValidation';
import template from './UploadPopup.vue';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		MDTextFieldWithValidation
	}
})
export default class UploadPopup extends Vue {
	@Prop({ default: false }) show!: boolean;

	@Prop() externalLoading!: boolean;

	@Prop() uploadPercentages!: UploadItem[];

	loading: boolean = true;
}
